import type { TFunction } from 'i18next';

import type { FeedingPen } from '@/domain/feedingDashboard';

import { formatDashboardDay } from '../dashboardDay';

export interface PenTag {
    id: 'historical' | 'noBioscope' | 'collecting';
    label: string;
    /** The full reason, for a reader who wants more than the tag. */
    title: string;
}

/**
 * The pen's own state, in the pen selector's words. A tag says once why every Bioscope
 * cell in the row is blank, where a title per cell reaches only a pointer user; the cell
 * titles stay for the rarer causes (a failed service call, an unmapped signal).
 */
export function penTags(pen: FeedingPen, t: TFunction): PenTag[] {
    const tags: PenTag[] = [];
    if (pen.historicalSince !== null) {
        tags.push({
            id: 'historical',
            label: t('feedingModule.filter.historical'),
            title: t('feedingModule.table.status.historicalSince', {
                day: formatDashboardDay(pen.historicalSince),
            }),
        });
    }
    // O13: a pen listed for its planning-system data alone, as the selector marks it.
    if (!pen.bioscopeInPeriod) {
        tags.push({
            id: 'noBioscope',
            label: t('feedingModule.filter.noBioscope'),
            title: t('feedingModule.kpi.excluded.noBioscope'),
        });
    } else if (pen.bioscopeDataQuality === 'collecting') {
        tags.push({
            id: 'collecting',
            label: t('feedingModule.table.status.collecting'),
            title: t('feedingModule.kpi.excluded.collecting'),
        });
    }
    return tags;
}
